import {FormControl, FormGroup} from "@angular/forms";
import {WasteCollectionAreaAppEntityWasteWasteCollectionAreaRead} from "../../../openapi";
import {NotificationFormData} from "../../../services/my-settings.common.service";

export class AreaForm extends FormGroup {

  public areas: WasteCollectionAreaAppEntityWasteWasteCollectionAreaRead[] = [];

  constructor() {
    super({});
  }

  public initForm(data: NotificationFormData): AreaForm {
    data.areas.forEach(item => {
      this.addControl(item?.uuid || '', new FormControl(data.subscribedAreas.includes(item?.uuid || '')))
    });
    this.areas = [...data.areas];
    return this;
  }

  public toWriteModel(): string[] {
    return this.areas
      .map(area => {
        if (this.get(area?.uuid || '')?.value) {
          return area?.uuid || '';
        } else {
          return '';
        }
      }).filter(Boolean);
  }

}
